<mat-card class="cur-card" style="padding-top: 30px; padding-bottom: 30px;" formGroupName="supplyresumptionResultInfo">
    <mat-card-content style="display: flex;"
        class="tw-flex tw-flex-row tw-flex-wrap tw-justify-start tw-content-center">
        <mat-radio-group id="actionTypeSagyokekka" color="warn" formControlName="supplystopresumptionResultDivcd"
            class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[330px] tw-max-w-[330px] tw-min-w-[330px] content-center"
            style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px; margin-top: 27px;">
            <mat-label class="mat-label-ragiogroup tw-flex "> 作業結果 *</mat-label>
            <mat-radio-button class="radio-button-margin tw-flex " [value]="code.userCode"
                *ngFor="let code of codeMap?.get('S300772')">{{code.hyojiCont}}</mat-radio-button>
        </mat-radio-group>

        <div [ngSwitch]="actionTypeSagyokekka" class="tw-flex tw-flex-row tw-flex-wrap">
            <div *ngSwitchCase="'0'" class="tw-flex tw-flex-row tw-flex-wrap">
                <mat-form-field appearance="outline" class="input-form-basic-info"
                    style="margin-top: 25px; margin-left: 30px;">
                    <mat-label>供給再開日 *</mat-label>
                    <input [matDatepicker]="resumptionSupplyDate" formControlName="supplyresumptionDate"
                        class="font-color-display-only" matInput autocomplete="off" maxlength="10" />
                    <mat-datepicker-toggle matSuffix [for]="resumptionSupplyDate"></mat-datepicker-toggle>
                    <mat-datepicker #resumptionSupplyDate [startAt]="resumptionSupplyDate"></mat-datepicker>
                </mat-form-field>

                <mat-form-field style="margin-top: 25px; margin-left: 30px;" appearance="outline"
                    class="input-form-basic-info remove-top ">
                    <mat-label>時刻 *</mat-label>
                    <input class="font-color-display-only" type="time" matInput formControlName="supplyresumptionHms"
                        style="margin-top: 7px;" autocomplete="off" />
                </mat-form-field>
            </div>

            <div *ngSwitchCase="'1'" class="tw-flex tw-flex-row tw-flex-wrap">
                <mat-form-field appearance="outline" class="input-form-basic-info"
                    style="margin-top: 25px; margin-left: 30px;">
                    <mat-label>再開作業日(変更前)</mat-label>
                    <input class="font-color-display-only" readonly="true" matInput id="bfSupplyresumptionScddt"
                        [value]="getControl('bfSupplyresumptionScddt').value|date :'yyyy/MM/dd'" autocomplete="off" />
                </mat-form-field>

                <p style="margin-top: 45px; padding-left: 15px; padding-right: 15px; font: size 60px;">▶</p>

                <mat-form-field appearance="outline" class="input-form-basic-info" style="margin-top: 25px;">
                    <mat-label>再開作業日(変更後) *</mat-label>
                    <input [matDatepicker]="changeAfterDate" formControlName="afSupplyresumptionScddt"
                        [min]="regDate" class=" font-color-display-only" matInput autocomplete="off" maxlength="10" />
                    <mat-datepicker-toggle matSuffix [for]="changeAfterDate"></mat-datepicker-toggle>
                    <mat-datepicker #changeAfterDate [startAt]="changeAfterDate"></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin-top: 25px; margin-left: 20px;">
                    <mat-label>作業希望時間帯 *</mat-label>
                    <mat-select formControlName="afSupplyresumptionYtitimez">
                        <mat-option value="" selected></mat-option>
                        <mat-option *ngFor="let div of codeMap?.get('S300530')" [value]="div.userCode">{{div.hyojiCont}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <mat-form-field appearance="outline" class="input-form-basic-info tw-flex "
            style="margin-top: 25px; margin-left: 20px;">
            <mat-label>登録日</mat-label>
            <input class="font-color-display-only" readonly="true" disabled matInput id="resumptionSupplyDate"
                [value]="regDate|date :'yyyy/MM/dd'" autocomplete="off" />
        </mat-form-field>
    </mat-card-content>
</mat-card>